import { useEffect, useState } from 'react';
import api from 'api';
import { FiDownload, FiEdit3, FiTrash2 } from 'react-icons/fi';
import { download, debug } from '../../../../utils';
import Swal from "sweetalert2";
export default function AdminFormalityResponsePanel({ request, onResponseDocumentsChanged }) {
  const [documents, setDocuments] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingDoc, setEditingDoc] = useState(null);
  const [docForm, setDocForm] = useState({
    frdLabel: '',
    frdDescription: '',
    frdCategory: '',
    frdVisibleForCustomer: 1,
    frdIsFinal: 0,
  });
  // --------------------------------------------------
  // Chargement initial des documents
  // --------------------------------------------------
  useEffect(() => {
    loadDocuments();
  }, [request.frId]);

  useEffect(() => {
    onResponseDocumentsChanged?.(documents);
  }, [documents]);


  const loadDocuments = async () => {
    try {
      const res = await api.get(
        `/admin/formalities/request/${request.frId}/response/documents`
      );
      setDocuments(res.data || []);

    } catch (e) {
      console.error(e);
    }
  };
  const handleFileSelect = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    try {
      await api.post(
        `/admin/formalities/request/${request.frId}/response/document`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      loadDocuments();
    } catch (e) {
      console.error(e);
    } finally {
      e.target.value = ''; // reset input
    }
  };
  const handleDownload = async (doc) => {
    download(`/admin/formalities/response/document/${doc.frdId}/download`);
  }
  const handleDelete = async (doc) => {
    try {
      const conf = await Swal.fire({
        title: 'Confirmation',
        html: `Confirmez-vous la suppression du document<br /><strong>${doc.frdLabel}</strong>&nbsp;?`,
        showCancelButton: true,
        confirmButtonText: 'Supprimer',
        cancelButtonText: 'Annuler',
        icon: undefined, // aucune icône
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-danger me-2',
          cancelButton: 'btn btn-outline-secondary',
        },
      });

      if (!conf.isConfirmed) {
        return;
      }
      await api.delete(
        `/admin/formalities/response/document/${doc.frdId}`
      );
      await loadDocuments();
    } catch (e) {
      console.error(e);
    }
  };

  const sanitizeName = (value = '') =>
    value
      .replace(/[\\/]/g, '') // interdit / et \
      .replace(/^\s+|\s+$/g, ''); // trim uniquement
  const openEditModal = (doc) => {
    setError(null);
    setEditingDoc(doc);
    setDocForm({

      frdLabel: doc.frdLabel || '',
      frdDescription: doc.frdDescription || '',
      frdCategory: doc.frdCategory || '',
      frdVisibleForCustomer: doc.frdVisibleForCustomer ? 1 : 0,
      frdIsFinal: doc.frdIsFinal ? 1 : 0,
    });
    setShowEditModal(true);
  };
  const handleUpdateDocument = async () => {
    if (!editingDoc) return;
    const frdLabel = docForm?.frdLabel?.trim();
    if (!frdLabel) {
      setError('Le libellé du document ne peut pas être vide.');
      return;
    }
    try {
      await api.put(
        `/admin/formalities/response/document/${editingDoc.frdId}`,
        docForm,
      );
      await loadDocuments();
      setShowEditModal(false);
      setEditingDoc(null);
    } catch (e) {
      console.error(e);
      setError(
        e?.response?.data?.error?.message ||
        'Erreur lors de la mise à jour du document'
      );
    }
  };


  // --------------------------------------------------
  // Render
  // --------------------------------------------------
  return (
    <div className="p-3">
      {/* Upload */}
      <label className="form-label small">
        Ajouter un document de réponse
      </label>
      <div className="mb-3 d-flex align-items-center gap-2 ">
        <div className='flex-grow-1'>
          <input
            type="file"
            className="form-control form-control-sm"
            disabled={uploading}
            onChange={handleFileSelect}
          />
          {false && selectedFile && (
            <div className="small text-muted mt-1">
              Fichier sélectionné : {selectedFile.name}
            </div>
          )}
        </div>
        {uploading && (
          <div className="text-muted small">
            <div className="spinner-border spinner-border-sm" role="status" />
          </div>
        )}
      </div>

      {/* Liste des documents */}
      {documents.length === 0 && (
        <div className="text-muted small">
          Aucun document de réponse.
        </div>
      )}
      {documents.map(doc => (
        <div
          key={doc.frdId}
          className="border rounded p-2 mb-2 d-flex justify-content-between align-items-center small"
        >
          <div>
            <strong>{doc.frdLabel}</strong>
            {doc.frdIsFinal === 1 && (
              <span className="badge bg-success ms-2">Final</span>
            )}
          </div>
          <div className="d-flex align-items-center gap-3">
            <FiDownload
              size={18}
              className="pointer"
              title="Télécharger"
              onClick={() => handleDownload(doc)}
            />
            <FiEdit3
              size={18}
              className="pointery"
              title="Éditer les informations du document"
              onClick={() => openEditModal(doc)}
            />
            <FiTrash2
              size={18}
              className="text-danger pointer"
              title="Supprimer"
              onClick={() => handleDelete(doc)}
            />
          </div>
        </div>
      ))}
      {showEditModal && (
        <>
          <div className="modal-backdrop fade show" />
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    Informations du document
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowEditModal(false)}
                  />
                </div>
                <div className="modal-body pb-1">

                  {/* Label */}
                  <div className="mb-3">
                    <label className="form-label">Libellé</label>
                    <input
                      type="text"
                      className="form-control"
                      value={docForm.frdLabel}
                      onChange={(e) =>
                        setDocForm({ ...docForm, frdLabel: e.target.value })
                      }
                    />
                  </div>
                  {/* Catégorie */}
                  <div className="mb-3 d-none" >
                    <label className="form-label">Catégorie</label>
                    <select
                      className="form-select"
                      value={docForm.category}
                      onChange={(e) =>
                        setDocForm({ ...docForm, category: e.target.value })
                      }
                    >
                      <option value="">—</option>
                      <option value="recap">Récapitulatif</option>
                      <option value="kbis">KBIS</option>
                      <option value="attestation">Attestation</option>
                      <option value="statuts">Statuts</option>
                      <option value="autre">Autre</option>
                    </select>
                  </div>
                  {/* Description */}
                  <div className="mb-3">
                    <label className="form-label">Description</label>
                    <textarea
                      className="form-control"
                      rows={3}
                      value={docForm.frdDescription}
                      onChange={(e) =>
                        setDocForm({ ...docForm, frdDescription: e.target.value })
                      }
                    />
                  </div>
                  {/* Options */}
                  <div className="form-check mb-2  d-none">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={!!docForm.frdVisibleForCustomer}
                      onChange={(e) =>
                        setDocForm({
                          ...docForm,
                          frdVisibleForCustomer: e.target.checked ? 1 : 0,
                        })
                      }
                    />
                    <label className="form-check-label">
                      Visible pour le client
                    </label>
                  </div>
                  <div className="form-check  d-none">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={docForm.isFinal}
                      onChange={(e) =>
                        setDocForm({
                          ...docForm,
                          isFinal: e.target.checked,
                        })
                      }
                    />
                    <label className="form-check-label">
                      Document final
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={!!docForm.frdIsFinal}
                      onChange={(e) =>
                        setDocForm({
                          ...docForm,
                          frdIsFinal: e.target.checked ? 1 : 0,
                        })
                      }
                    />

                  </div>
                  {error && (
                    <div className="alert alert-danger small py-1 px-2 mt-2">
                      {error}
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => setShowEditModal(false)}
                  >
                    Annuler
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={handleUpdateDocument}
                  >
                    Enregistrer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
